import TelegramChannelApi from './TelegramChannelApi';
import {
  TELEGRAM_CHANNEL_BATCH_SIZE_CHANGE_CURRENT,
  TELEGRAM_CHANNEL_BOT_TOKEN_CHANGE_CURRENT,
  TELEGRAM_CHANNEL_CREATE_FETCH,
  TELEGRAM_CHANNEL_CREATE_FETCH_FAIL,
  TELEGRAM_CHANNEL_CREATE_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_DELETE_FETCH,
  TELEGRAM_CHANNEL_DELETE_FETCH_FAIL,
  TELEGRAM_CHANNEL_DELETE_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_INFO_FETCH,
  TELEGRAM_CHANNEL_INFO_FETCH_FAIL,
  TELEGRAM_CHANNEL_INFO_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_LIST_FETCH,
  TELEGRAM_CHANNEL_LIST_FETCH_FAIL,
  TELEGRAM_CHANNEL_LIST_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_NAME_CHANGE_CURRENT,
  TELEGRAM_CHANNEL_UPDATE_FETCH,
  TELEGRAM_CHANNEL_UPDATE_FETCH_FAIL,
  TELEGRAM_CHANNEL_UPDATE_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_VIEW_FETCH,
  TELEGRAM_CHANNEL_VIEW_FETCH_FAIL,
  TELEGRAM_CHANNEL_VIEW_FETCH_SUCCESS,
} from './TelegramChannelConstants';
import { showMessage } from '../../../utils/RenderUtils';

export function telegramChannelChangeCurrent(value, type) {
  return (dispatch) => {
    switch (type) {
      case 'name':
        {
          dispatch({
            type: TELEGRAM_CHANNEL_NAME_CHANGE_CURRENT,
            payload: value,
          });
        }
        break;
      case 'botToken':
        {
          dispatch({
            type: TELEGRAM_CHANNEL_BOT_TOKEN_CHANGE_CURRENT,
            payload: value,
          });
        }
        break;
      case 'batchSize':
        {
          dispatch({
            type: TELEGRAM_CHANNEL_BATCH_SIZE_CHANGE_CURRENT,
            payload: value,
          });
        }
        break;
    }
  };
}

const loadTelegramChannelList = (dispatch, pageRequest = {}) => {
  dispatch({
    type: TELEGRAM_CHANNEL_LIST_FETCH,
    payload: pageRequest,
  });
  TelegramChannelApi.list()
    .then((response) => {
      dispatch({
        type: TELEGRAM_CHANNEL_LIST_FETCH_SUCCESS,
        payload: response,
      });
    })
    .catch((response) => {
      dispatch({
        type: TELEGRAM_CHANNEL_LIST_FETCH_FAIL,
        payload: response,
      });
    });
};

export function telegramChannelListFetch(pageRequest) {
  return (dispatch) => loadTelegramChannelList(dispatch, pageRequest);
}

export function telegramChannelCreateFetch(payload, cb) {
  return (dispatch) => {
    dispatch({
      type: TELEGRAM_CHANNEL_CREATE_FETCH,
      payload: payload,
    });
    TelegramChannelApi.create(payload)
      .then((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_CREATE_FETCH_SUCCESS,
          payload: response,
        });
        if (response) {
          showMessage(
            'Bot token has been validated successfully',
            'success',
            'Integeration Success'
          );
          if (cb) cb();
          loadTelegramChannelList(dispatch);
        }
      })
      .catch((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_CREATE_FETCH_FAIL,
          payload: response,
        });
      });
  };
}

export function telegramChannelInfoFetch(id) {
  return (dispatch) => {
    dispatch({
      type: TELEGRAM_CHANNEL_INFO_FETCH,
    });
    TelegramChannelApi.info(id)
      .then((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_INFO_FETCH_SUCCESS,
          payload: response,
        });
      })
      .catch((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_INFO_FETCH_FAIL,
          payload: response,
        });
      });
  };
}

export function telegramChannelDeleteFetch(id) {
  return (dispatch) => {
    dispatch({
      type: TELEGRAM_CHANNEL_DELETE_FETCH,
    });
    TelegramChannelApi.delete(id)
      .then((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_DELETE_FETCH_SUCCESS,
        });
        if (response) {
          showMessage('Bot has been deleted successfully', 'success');
          loadTelegramChannelList(dispatch);
        }
      })
      .catch((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_DELETE_FETCH_FAIL,
          payload: response,
        });
      });
  };
}

export function telegramChannelUpdateFetch(id, body, cb) {
  return (dispatch) => {
    dispatch({
      type: TELEGRAM_CHANNEL_UPDATE_FETCH,
    });
    TelegramChannelApi.update(id, body)
      .then((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_UPDATE_FETCH_SUCCESS,
        });
        if (response) {
          showMessage(
            'Bot configuration has been updated successfully',
            'success'
          );
          loadTelegramChannelList(dispatch);
          if (cb) cb();
        }
      })
      .catch((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_UPDATE_FETCH_FAIL,
          payload: response,
        });
      });
  };
}

export function telegramChannelViewFetch(id) {
  return (dispatch) => {
    dispatch({
      type: TELEGRAM_CHANNEL_VIEW_FETCH,
    });
    TelegramChannelApi.view(id)
      .then((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_VIEW_FETCH_SUCCESS,
          payload: response,
        });
      })
      .catch((response) => {
        dispatch({
          type: TELEGRAM_CHANNEL_VIEW_FETCH_FAIL,
          payload: response,
        });
      });
  };
}
